import React from 'react';
import Header from '../components/Header';
import Calculator from '../components/Calculator';

const CalculatorPage = () => (
  <main>
    <Header />
    <Calculator />
  </main>
);

export default CalculatorPage;
